import Loadable from 'react-loadable'

export default Loadable({
  loader: () => import(/* webpackChunkName: "enroll" */ './index'),
  loading: () => null,
})
